export default __webpack_public_path__ + "static/media/package-3.1886a804.png";